export default{
    getCategoryFilter: state => state.filter,
    getCategoryList: state => state.list,
    getCategoryValidation: state => state.validation
}